import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../tables/Table';

import useCustomTable from '../../tables/useCustomTable';
import * as Format from "../../Format";
import Pagination from "../../tables/Pagination";
import Block from "../../Block";
import {OsIcon} from "../../OsIcon";
import EnvironmentCell from "../../metrics/tables/cells/EnvironmentCell";
import {CellTwoLines} from "../../tables/CellTwoLines";
import {formatDate} from "../../Format";
import versionCompare from "../../../services/versionCompare";
import FilterButton, {FilterGroup} from "../../FilterButton";
import TableSearch from "../../tables/TableSearch";
import {useHistory} from "react-router-dom";

const ConsentByAppTable = ({data = [], isSuccess, isFetching: isLoading, refetch}) => {

  const { t } = useTranslation();
  const history = useHistory();

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {name: 'asc'},
    initialFilters: [{id: "environment", value: ["production"]}]
  });

  const columns = [{
    Header: t("cmp.analytics.metrics.name"),
    accessor: 'name',
  },{
    Header: 'OS',
    id: 'os',
    Cell: ({row}) => (<OsIcon os={row.original.os} style={{fontSize: "2em"}} />),
  },{
    Header: t("cmp.analytics.metrics.environment"),
    id: 'environment',
    Cell: ({row}) => (<EnvironmentCell row={row.original} />),
  },{
    Header: t("cmp.analytics.metrics.productionSdk"),
    id: 'productionSdk',
    Cell: ({row}) => (<CellTwoLines text={row.original.sdkProdVersion} subtext={formatDate(row.original.sdkProdDate)}/>),
    sortType: (rowA, rowB, id, desc) => (versionCompare(rowB.original.sdkProdVersion,rowA.original.sdkProdVersion))
  },{
    Header: t("cmp.analytics.metrics.testSdk"),
    id: 'testSdk',
    Cell: ({row}) => (<CellTwoLines text={row.original.sdkTestVersion} subtext={formatDate(row.original.sdkTestDate)}/>),
    sortType: (rowA, rowB, id, desc) => (versionCompare(rowB.original.sdkTestVersion,rowA.original.sdkTestVersion))
  },{
    Header: t("cmp.analytics.metrics.devices"),
    accessor: 'devices',
  },{
    Header: t("cmp.analytics.metrics.devicesWithCmpPresented"),
    accessor: 'devicesWithCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.presentationRate"),
    Cell: ({row}) => <Format.Percent value={row.original.presentationRate*100}/>,
    accessor: 'presentationRate',
  },{
    Header: t("cmp.analytics.metrics.consentedDevices"),
    accessor: 'consentedDevices',
  },{
    Header: t("cmp.analytics.metrics.consentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.consentRate*100}/>,
    accessor: 'consentRate',
  }
  ];

  const dataToTableRow = (el) => ({
    ...el,
    presentationRate: (el.devices || 0) > 0 ? el.devicesWithCmpPresented/el.devices : 0,
    consentRate: (el.devicesWithCmpPresented || 0) > 0 ? el.consentedDevices/el.devicesWithCmpPresented : 0
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  const onRowClick = (data) => history.push(`/apps/${data.id}/cmp/analytics`)

  return (
    <>
      <FilterGroup {...tableFilterProps}>
        <FilterButton
          title={t("cmp.analytics.metrics.environment")}
          options={["production", "test"]}
          search={false}
          includeAll={true}
          name="environment"/>
        <TableSearch {...tableSearchProps} style={{float: "right"}}/>
      </FilterGroup>
      <Block isLoading={isLoading} isSuccess={isSuccess}>
        <Table noPadding data={tableData} columns={columns} onRowClick={onRowClick} {...tableProps}/>
      </Block>
      {isSuccess && !isLoading && <Pagination {...paginationProps}/>}
    </>)
}

export default ConsentByAppTable
